// Capture the Google Ads click id (gclid / gbraid / wbraid) and UTM parameters
// when a visitor lands from an ad, and persist them in localStorage. This is the
// website half of closing the ad -> trial -> paid attribution gap: the stored
// click id can later be handed to the desktop app / backend so an eventual paid
// subscription can be reported back to Google Ads (offline conversion import).
//
// See docs/attribution-plan.md for the full end-to-end design.

const STORAGE_KEY = 'rn_attribution';
const PARAMS = [
  'gclid',
  'gbraid',
  'wbraid',
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
];

function readStore() {
  try {
    return JSON.parse(window.localStorage.getItem(STORAGE_KEY)) || {};
  } catch (e) {
    return {};
  }
}

/**
 * Reads attribution params off the current URL and persists first-touch +
 * last-touch. Safe to call on every page load; no-ops when no params present.
 */
export function captureAttribution() {
  try {
    const query = new URLSearchParams(window.location.search);
    const found = {};
    PARAMS.forEach((p) => {
      const v = query.get(p);
      if (v) found[p] = v;
    });
    if (!Object.keys(found).length) return;

    const touch = {
      ...found,
      ts: new Date().toISOString(),
      landing: window.location.pathname,
      referrer: document.referrer || '',
    };
    const store = readStore();
    if (!store.firstTouch) store.firstTouch = touch;
    store.lastTouch = touch;
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
  } catch (e) {
    /* storage unavailable (private mode etc.) — ignore */
  }
}

/** Returns the stored attribution object, or null. */
export function getAttribution() {
  const store = readStore();
  return Object.keys(store).length ? store : null;
}

// Expose a getter so the download flow / app handoff can read it.
if (typeof window !== 'undefined') {
  window.rnGetAttribution = getAttribution;
}
